import { Icon, PopoverTrigger, Typography } from '@epilot/concorde-elements'
import { type Price } from '@epilot/journey-logic-commons'

import classes from './ProductTileMappingDataTriggerButton.module.scss'

type ProductTileMappingDataTriggerButtonProps = {
  className?: string
  handleMouseEnter: () => void
  handleMouseLeave: () => void
  formattedQuantity?: string
  displayUnitaryAverage?: boolean
  formattedAverage?: string
  showPriceDescription?: boolean
  price: Price
  displayInOneLine?: boolean
}

const ProductTitleMappingDataTriggerButton = ({
  handleMouseEnter,
  handleMouseLeave,
  displayUnitaryAverage,
  formattedAverage,
  showPriceDescription,
  price
}: ProductTileMappingDataTriggerButtonProps) => {
  return (
    <div className={classes.productMappingDataTriggerButton}>
      <Typography
        className={classes.text}
        data-testid="product-mapping-data-graduated-description"
        title={price.description}
        variant="secondary"
      >
        {showPriceDescription ? `${price.description}` : ''}
      </Typography>

      <PopoverTrigger
        asChild
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <button className={classes.button}>
          {/**
           * Triggering console error:
           * Warning: validateDOMNesting(...): <div> cannot appear as a descendant of <p>. Error Component Stack
           * @todo Fix markup to not render a <div> inside a <p>
           */}
          <Typography className={classes.price}>
            <div
              className={classes.button}
              data-testid="product-mapping-data-graduated-average-container"
            >
              <span>{displayUnitaryAverage && `Ø ${formattedAverage}`}</span>
              <Icon
                className={classes.icon}
                data-testid="tooltip"
                name={'info'}
              />
            </div>
          </Typography>
        </button>
      </PopoverTrigger>
    </div>
  )
}

ProductTitleMappingDataTriggerButton.displayName =
  'ProductTitleMappingDataTriggerButton'

export { ProductTitleMappingDataTriggerButton }
